import { useState, useEffect, useRef } from 'react'
import styles from './index.module.scss'
import { setCookie, getCookie } from './utils'

export default function DownTime(props) {
  let downTimer = useRef<any>(null)

  const [min, setMin] = useState(getCookie('countDown') || 10)
  const [sec, setSec] = useState(getCookie('countDownSeconds') || 0)

  const getDownTime = () => {
    let m = +getCookie('countDown')
    let s = +getCookie('countDownSeconds')
    downTimer.current = setInterval(() => {
      if (m === 0 && s === 0) {
        s = 0
        setSec(s)
        clearInterval(downTimer.current)
        downTimer.current = null
        console.log('props?.close~~ 倒计时结束 ' );
        
        props?.close()
        return
      }

      if ((s === 0 || s <0)&& m !== 0) {
        s = 59
        m--
      } else {
        s--
      }
      setSec(s)
      setMin(m)
    }, 1000)
  }

  const minutes = () => {
    return (min + '').length < 2 ? '0' + min : min
  }

  const seconds = () => {
    return (sec + '').length < 2 ? '0' + sec : sec
  }
  useEffect(() => {
    setCookie('countDown', min)
  }, [min])
  useEffect(() => {
    setCookie('countDownSeconds', sec)
  }, [sec])

  useEffect(() => {
    getDownTime()
    return () => {
      if (downTimer.current) {
        clearInterval(downTimer.current)
        downTimer.current = null
      }
    }
  }, [])
  return (
    <div className="flex items-center justify-center h-[20px]">
      <div className={styles['box']}>{minutes()}</div>
      <div className={styles['spc']}>:</div>
      <div className={styles['box']}>{seconds()}</div>
    </div>
  )
}
